import { createAction } from 'redux-actions';
import { PapiUser } from '@wix/da-papi-types';

export const leaveGroup = createAction('LEAVE_GROUP', (group: PapiUser) => ({
  group,
}));

export const leaveGroupSuccess = createAction(
  'LEAVE_GROUP_SUCCESS',
  (group: PapiUser) => ({
    group,
  })
);
